module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "layout"
    }
  }, [(_vm.showSelf) ? _c('div', {
    staticClass: "toast"
  }, [(_vm.icon !== '') ? _c('i', {
    staticClass: "icon iconfont",
    class: [
      'icon-' + _vm.icon[_vm.typeSelf],
      _vm.typeSelf === 'loading' ? 'loading' : ''
    ]
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.contentSelf) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1542f3f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/toast.vue
// module id = 227
// module chunks = 36